<template>
  <self-service-panel />
</template>
<script>
import SelfServicePanel from '../components/SelfServicePanel'
export default {
  name: 'SelfServicePage',
  components: {
    SelfServicePanel
  }
}
</script>